export default __webpack_public_path__ + "svg/calendar/2026/4/abril.svg?321fb480";